import request from '@/utils/request'
import {AxiosResponse} from 'axios';



export interface ITopologyConfig {
  zoom: number;
  pan: Position;
  nodes: {
    [node_id: string]: Position;
  }
}


export interface ITopologiesConfig {
  [topology_id: string]: ITopologyConfig;
}

class UserConfig {
  topologies?: ITopologiesConfig;
}

class UserConfigService {

  public config: UserConfig = new UserConfig();

  clearConfig() {
    this.config = new UserConfig();
  }

  async getUserConfig(): Promise<void> {
    const userId = localStorage.getItem('user_id');
    if (!userId) {
      this.clearConfig();
      return;
    }
    const resp: AxiosResponse['data'] = await request({
      url: `admin/user/${userId}/config`,
      method: 'get'
    });
    if (resp && resp.data && resp.data.config) {
      this.config = resp.data.config;
    }
    console.log('finished');
  }

  async saveUserConfig(): Promise<void> {
    const userId = localStorage.getItem('user_id');
    if (userId) {
      const resp: AxiosResponse['data'] = await request({
        url: `admin/user/${userId}/config`,
        method: 'put',
        data: {user_id: userId, config: this.config}
      });

      if (resp && resp.config) {
        this.config = resp.config;
      }
    } else {
      throw new Error('User id not set');
    }
  }

}

export default new UserConfigService();
